"use client";

import React from "react";
import { Box, Stack } from "@mui/material";
import InstagramIcon from "@mui/icons-material/Instagram";
import CrowdRiffGallerySection from "@/components/common/crowdriff-gallery/crowd-riff-gallery-section";
import { CrowdRiffSection } from "@/types/dto/destinations-page/destination-page-types";

interface MakingPositiveImpactProps {
  crowdRiffData: CrowdRiffSection;
  dataModuleRanking?: string;
}

const MakingPositiveImpact: React.FC<MakingPositiveImpactProps> = ({
  crowdRiffData,
  dataModuleRanking
}) => (
    <Box
      component="section"
      data-track="visibility"
      data-parent-container-type="making-positive-impact"
      data-module-name="Making Positive Impact"
      data-ranking-algorithm="manual"
      data-module-ranking-position={dataModuleRanking}
      className="fluid-box"
    >
      <Stack
        alignItems="center"
        className="full-width-container"
        sx={{ padding: { xs: "2.8rem 2.4rem 0", sm: "2.8rem 3.2rem 0", lg: "2.8rem 10rem 0" } }}
      >
        {/* CrowdRiff Gallery Section */}
        {crowdRiffData && (
          <Box
            sx={{
              width: "100%"
            }}
          >
            <CrowdRiffGallerySection
              crowdRiffSection={crowdRiffData}
              showCopyText
              sectionHeaderCentered
              moduleRankingPosition={dataModuleRanking}
              headerSx={{ textAlign: "center", textTransform: "none" }}
              socialLink={{
                href: "https://www.instagram.com/collettecares/",
                ariaLabel: "Visit ColletteCares on Instagram",
                icon: <InstagramIcon sx={{ fontSize: "2rem", color: "secondary.main" }} />,
                label: "ColletteCares"
              }}
            />
          </Box>
        )}
      </Stack>
    </Box>
);

export default MakingPositiveImpact;
